// Duration for error/message dismissal
export const MESSAGE_DISPLAY_DURATION_MS = 3000;

// Shared animation configuration for dictation bubble enter
// Uses ease-out-quint easing for smooth deceleration
export const bubbleEnterAnimation = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 1, y: 0 },
  transition: { duration: 0.2, ease: [0.23, 1, 0.32, 1] },
} as const;

// Exit-only animation (no enter animation, fade out + slide down on exit)
export const bubbleExitAnimation = {
  initial: false,
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: { duration: 0.2, ease: [0.23, 1, 0.32, 1] },
} as const;
